import * as MT from "./mutationTypes";
import Vue from "vue";

export default {
  [MT.SET_STATES]: (state, data) => (state.states = data.states),
  [MT.SET_CITIES]: (state, data) => (state.cities = data.cities),
  [MT.SET_UNITS]: (state, data) => (state.units = data.units),
  [MT.SET_ACCESSORIES]: (state, data) => (state.accessories = data.accessories),
  [MT.SET_CESS]: (state, data) => (state.cess = data.cess),
  [MT.SET_CESS_GENERAL_DUTY]: (state, data) => (state.cessGeneralDuty = data.cessGeneralDuty),
  [MT.SET_CONTAINER_SEAL_TYPES]: (state, data) => (state.containerSealTypes = data.containerSealTypes),
  [MT.SET_CONTAINER_SIZES]: (state, data) => (state.containerSizes = data.containerSizes),
  [MT.SET_CONTAINER_TYPES]: (state, data) => (state.containerTypes = data.containerTypes),
  [MT.SET_COUNTRIES]: (state, data) => (state.countries = data.countries),
  [MT.SET_DISTRICT_CODES]: (state, data) => (state.districtCodes = data.districtCodes),
  [MT.SET_DOCUMENT_TYPE_CODES]: (state, data) => (state.documentTypeCodes = data.documentTypeCodes),
  [MT.SET_CURRENCIES]: (state, data) => (state.currencies = data.currencies),
  [MT.SET_DECLARATIONS]: (state, data) => (state.declarations = data.declarations),
  [MT.SET_RODTEPS]: (state, data) => (state.rodteps = data.rodteps),
  [MT.SET_END_USES]: (state, data) => (state.endUses = data.endUses),
  [MT.SET_EXPORTER_TYPES]: (state, data) => (state.exporterTypes = data.exporterTypes),
  [MT.SET_EXPORT_UNDERS]: (state, data) => (state.exportUnders = data.exportUnders),
  [MT.SET_GOODS_STUFFED_AT]: (state, data) => (state.goodsStuffedAt = data.goodsStuffedAt),
  [MT.SET_GST_IN_TYPES]: (state, data) => (state.gstInTypes = data.gstInTypes),
  [MT.SET_IGST_PAYMENT_STATUS]: (state, data) => (state.igstPaymentStatus = data.igstPaymentStatus),
  [MT.SET_NATURE_OF_CARGO]: (state, data) => (state.natureOfCargo = data.natureOfCargo),
  [MT.SET_SEAL_TYPES]: (state, data) => (state.sealTypes = data.sealTypes),
  [MT.SET_SHIPMENT_TYPES]: (state, data) => (state.shipmentTypes = data.shipmentTypes),
  [MT.SET_SHOW_FOB_INS]: (state, data) => (state.showFOBIns = data.showFOBIns),
  [MT.STORE_SHOW_NATURE_OF_PAYMENTS]: (state, data) => (state.natureOfPayments = data.natureOfPayments),
  [MT.STORE_SHOW_NATURE_OF_PAYMENTS]: (state, data) => (state.natureOfPayments = data.natureOfPayments),
  [MT.SET_TERMS_OF_INVOICES]: (state, data) => (state.termsOfInvoices = data.termsOfInvoices),
  [MT.SET_UNIT_PRICE_INCLUDES]: (state, data) => (state.unitPriceIncludes = data.unitPriceIncludes),
  [MT.SET_RITC_CODES]: (state, data) => (state.ritcCodes = data.ritcCodes),
  [MT.SET_EXIM_SCHEME_CODES]: (state, data) => (state.eximSchemeCodes = data.eximSchemeCodes),
  [MT.SET_FOREIGN_PORTS]: (state, data) => (state.foreignPorts = data.foreignPorts),
  [MT.SET_HOME_PORTS]: (state, data) => (state.homePorts = data.homePorts),
  [MT.SET_PTA_FTAS]: (state, data) => (state.ptaFtas = data.ptaFtas),
  [MT.SET_DRAW_BACK_RATES]: (state, data) => (state.drawbackRates = data.drawbackRates),
  [MT.STORE_ESANCHIT_SUPPORTING_DOCS]: (state, data) => {
    const supportingDocs = data.data.map(supportingDoc => {
      const id = supportingDoc.id;
      const obj = {
        ...supportingDoc.json_data
      };
      obj.id = id;
      return obj;
    });
    Vue.set(state, "esanchitSupportingDocs", [...supportingDocs]);
    return;
  }
};
